module.exports = __webpack_public_path__ + "static/media/loginBackground.d47262f9.jpg";